<template>
  <div class="helpWrapper" :data-theme="theme" v-html="helpPage"></div>
</template>

<script>
export default {
  name: 'Help',
  props: {
    helpPage: String,
    theme: String,
  },
};
</script>

<style lang="scss">
:root {
  --help-background-color: #2C2E30;
  --help-text-color: #EFEFEF;
  --help-button-color: #404245;
  --help-button-color-border: #575757;
  --help-schedule-background-color: #4C4F52;
  --help-schedule-highlight-color: #1565C1;
}

[data-theme='light'] {
  --help-background-color: #f4f4f4;
  --help-text-color: #1f2123;
  --help-button-color: #DEDEDE;
  --help-button-color-border: #ffffff00;
  --help-schedule-background-color: #DEDEDE;
  --help-schedule-highlight-color: #1565C1;
}


.helpWrapper {
  width: 100%;
  height: 100vh;
  border: none;
  background-color: var(--help-background-color);

  ::-webkit-scrollbar {
    width: 3px;
  }

  ::-webkit-scrollbar-track {
    background: var(--help-background-color);
  }

  ::-webkit-scrollbar-thumb {
    background: #3F4144;
    border-radius: 3px;
  }

  .main {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 500px;
    width: 100%;

    .card {
      background-color: transparent;
      border: none;
      padding: 24px;
      max-width: 400px;
      color: var(--help-text-color);
      font-size: 14px;
      text-align: center;

      h1 {
        font-size: 20px;
        margin-bottom: 12px;
      }

      p {
        margin-bottom: 12px;
        line-height: 1.4;
      }

      a {
        color: var(--help-schedule-highlight-color);
        text-decoration: underline;
      }

      hr {
        margin: 16px 0;
        border: none;
        border-top: 1px solid var(--help-button-color-border);
      }
    }

    .code {
      font-size: 48px;
      font-weight: 800;
      color: var(--help-schedule-highlight-color);
      margin-bottom: 16px;
    }
  }

  .helpContainer {
    padding: 24px;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    gap: 16px;

    ul {
      padding: 16px 0 16px 24px;
    }

    .section {
      .title {
        font-weight: 700;
        margin-bottom: 8px;
        color: var(--help-text-color);
      }

      .content {
        color: var(--help-text-color);
        opacity: 0.7;
      }

      .paytable-container {
        width: 100%;

        .paytable {
          border-collapse: collapse;
          font-size: 13px;
          color: var(--help-text-color);

          .table-main-title {
            text-align: center;
            color: white;
          }

          tr,
          th,
          td {
            border: 1px solid var(--help-text-color);
          }

        }
      }

      .table-info {
        width: 100%;
        margin: 8px 0 24px 0;
        border-spacing: 0;
        border-collapse: collapse;

        tr,
        td {
          width: 50%;
          padding: 8px;
          border: 1px solid var(--help-text-color);

          .button {
            background-color: var(--help-button-color);
            color: var(--help-text-color);
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 2px;
            opacity: 1;
          }

          .button-wide {
            height: 35px;
            width: 144px;
          }

          .button-short {
            height: 35px;
            width: 35px;
          }

          .button-flex {
            display: flex;
            gap: 3px;
          }

          .payin-button {
            background-color: #398e3d;
            color: white;
          }

          .betslip-button {
            color: #ffc105;
            font-weight: bold;
            border-bottom: 2px solid #ffc105;
          }

          .future {
            border-radius: 0;
            justify-content: left;
            padding-left: 8px;
            width: 100px;
          }

          .future-text {
            font-size: 13px;
          }

          .future-text :nth-child(1) {
            opacity: 0.6;
          }

          .colors-wrapper {
            display: flex;
            flex-wrap: wrap;
            gap: 5px;
          }

          .colors-wrapper .color {
            height: 10px;
            width: 10px;
            border-radius: 50%;
            border: 1px solid var(--help-button-color-border);
          }

          .schedule-wrapper {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;

            .schedule-wrapper-button {
              width: 120px;
              border-radius: 0;
              background-color: var(--help-schedule-background-color);

              &:nth-child(1) {
                background-color: var(--help-schedule-highlight-color);
                color: white;
              }

              display: flex;
              align-items: center;
              justify-content: center;
            }

            .schedule-wrapper-info {
              font-size: 12px;
              text-align: center;
            }
          }

          .next-six-color-wrapper {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            .next-six-button {
              width: 145px;
              border-radius: 0;
              width: 100%;
              font-size: 12px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 0 10px;
              .next-six-color-wrapper {
                height: 17px;
                display: flex;
                gap: 1.5px;
                width: fit-content;
                .next-six-color {
                  height: 100%;
                  width: 3px;
                  background-color: rgb(0, 0, 0);
                  &:nth-child(-n+4) {
                    background-color: #70ff53;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .helpWrapper {
    .helpContainer {
      .section {
        .paytable-container {
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
          scrollbar-width: none;
        }
      }
    }
  }
}
</style>
